<template>
<div class="chapter">
<div class="inner_page">
<p class="chap-title"><span>BLUE YODEL 8</span></p>
<p class="chap-subtitle1"><span>HASKELL</span></p>
<p class="indent"><i>One thing I emphasize when I speak to groups of men is that so-called performance anxiety is a myth. From time to time over the years, a man would tell a woman he had performance anxiety so that she would regard him as a challenge. Sometimes it worked. If it didn’t, he told her he was just kidding and asked her if she would like another glass of wine</i>.</p>
<p class="indent"><i>A normal man can do anything. If he wants to. It’s as simple as that. And normal men have traditionally taken this for granted</i>.</p>
<p class="indent"><i>Unfortunately women psychiatrists</i> — <i>on whom the performance-anxiety gambit has worked at some point in their lives</i> — <i>have started diagnosing “performance anxiety” in their men patients. And sometimes these patients believe them. That’s why it is necessary that we as normal men get together</i> — <i>at the Century Club, for instance</i> — <i>and refresh ourselves as to basic principles. Such as, that a normal man can do anything he wants to do. And he always wants to. Unless he is tired</i>.</p>
<p class="indent"><i>When I speak to men’s groups I usually illustrate my point by singing a blues song. Blind Sweet Papa Joe Tatum’s “If Only All the Rest of Y’ all Weren’t Having Such a Fine Time Blues</i>.”</p>
<p class="indent"><i>Now I went to Choate, Brown, and Harvard Law. My specialty was strikebreaking law until my firm started representing the Teamsters. I own beautiful vacation homes in four different military dictatorships. Furthermore I have this rather fluty voice and can’t be bothered to keep time</i>.</p>
<p class="indent"><i>If I can get up before people and sing a blues song, then how can there be any such thing as performance anxiety? In normal men</i>.</p>
<p class="indent"><i>I define a normal man as one who can eat two hamburgers</i>.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter15.vue?589c00ca